<template>
    <div class="dataList">
        <div class="path path1" v-if="pulse[0].show"><img :src="img(require('@/assets/images/GIF/cePath1.gif'))"></div>
        <div class="path path2" v-if="pulse[1].show"><img :src="img(require('@/assets/images/GIF/cePath2.gif'))"></div>
        <div class="path path3" v-if="pulse[2].show"><img :src="img(require('@/assets/images/GIF/cePath3.gif'))"></div>
        <div class="path path4" v-if="pulse[3].show"><img :src="img(require('@/assets/images/GIF/cePath4.gif'))"></div>
        <div class="path path5" v-if="pulse[4].show"><img :src="img(require('@/assets/images/GIF/cePath5.gif'))"></div>
        <div class="path path6" v-if="pulse[5].show"><img :src="img(require('@/assets/images/GIF/cePath6.gif'))"></div>
        <ul class="list">
            <li v-for="(item,index) in dataList"
                v-if="index >= dataListIndex && index <= dataListShowMax + dataListIndex-1 "
            ><span>{{ item.group }}</span><span>{{ item.count }}</span></li>

        </ul>
        <div class="circular">
            <p id="num_ce_text">0</p>
            <main>
                <h3>策</h3>
                <div class="beam"></div>
                <div class="bg rotateX">
                    <div class="rotateZ"></div>
                </div>
            </main>
        </div>
    </div>
</template>

<script>
    import {numAnimation} from "../../assets/js/common";

    export default {
        name: "ceModule",
        data() {
            return {
                amount: 0,
                dataList: [],
                dataListIndex:0,
                dataListShowMax:6,//最多显示条数

                //定时器
                interval:null,
                timer: null,

                pulse: [
                    {show: false, dur: 2100},
                    {show: false, dur: 2000},
                    {show: false, dur: 1500},
                    {show: false, dur: 600},
                    {show: false, dur: 800},
                    {show: false, dur: 1000}
                ],
                during: 2000,
            }
        },
        mounted(){
            this.getAmount();
            this.intervalInit();
            this.timer =setInterval(() => {
                this.getAmount();
            }, 1000*60*15);
        },
        watch:{
            dataList(n, o) {
                let _that = this;
                let changeArr = [];
                // 比对新老数据,监测到不一样的数据，将索引插入到队列中
                n.forEach(function (item,index,arr) {
                    if (o[index]){
                        if (item.count!==o[index].count || item.group!==o[index].group) {
                            _that.pulse[index].show = true;
                            changeArr.push(_that.pulse[index].dur);
                        }
                    } else if (index < 6) {
                        _that.pulse[index].show = true;
                        changeArr.push(_that.pulse[index].dur);
                    }
                });
                this.during = Math.max(...changeArr);
            },
            amount: function (n, o) {
                let _that = this;
                if (n !== o && n !== 0) {
                    setTimeout(() => {
                        _that.pulse.forEach((item)=>{
                            item.show = false;
                        });
                        numAnimation("num_ce_text", {
                            time: 1500,
                            num: n,
                            regulator: 100,
                            start: o ? o : 0,
                        });
                    }, this.during);
                }
            },

        },
        computed: {
            img(){
                return function (path) {
                    return path + '?' + new Date().getTime();
                }
            },
        },
        methods:{
            getAmount(){
                this.axios.get('/bigscreen/xuantitongji_list.json').then(res => {
                    if (res.data.data.count && res.data.data.count > 0){
                        this.amount = res.data.data.count;
                        this.getDataList(res.data.data.data)
                    }
                });
            },
            getDataList(data){
                var _that = this;

                if (data.length === 0){
                    _that.dataList = [{
                        group:'没有找到选题',
                        count: ''
                    }]
                }else{
                    _that.dataList = data;
                }
            },
            intervalInit(){
                let _that = this;
                clearInterval(_that.interval);
                _that.interval = setInterval(function () {
                    _that.dataListIndex ++;
                    if (_that.dataListIndex > _that.dataList.length - _that.dataListShowMax){
                        _that.dataListIndex = 0;
                    }
                },5000)
            },
        },
        beforeDestroy(){
            let _that = this;
            clearInterval(_that.interval);
            clearInterval(_that.timer);
        },
    }
</script>

<style scoped>
    .dataList{
        height: 534px;
    }
    .dataList .path{
        width: 54px;
        height: 461px;
        position: absolute;
        right: -53px;
        top: 33px;
    }
    .dataList .list{
        height: 521px;
        width: 276px;
        background: url("../../assets/images/ceAllBG.png") center center no-repeat;
        background-size: 100% 100%;
    }
    .dataList .list li{
        /*background: url("../../assets/images/ceBG.png") center center no-repeat;*/
        /*background-size: 100% 100%;*/
        width: 264px;
        height: 71px;
        line-height: 71px;
        font-size: 24px;
        display: flex;
        justify-content: space-around;
        margin-bottom: 19px;
        position: relative;
        padding: 0 6px;
    }
    .dataList .list li span:first-child{
        width: 220px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .circular{
        width: 184px;
        height: 184px;
        position: absolute;
        right: -230px;
        bottom: 96px;
    }
    .circular main{
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .circular .bg{
        width: 100%;
        height: 100%;
        background-size: 100% 100%;
        position: absolute;
        top: 0;
        left: 0;
    }
    .circular .bg.rotateX{
        transform: rotateX(60deg);
    }
    .circular .rotateZ{
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background: url("../../assets/images/circle.png") center center no-repeat;
        background-size: 100% 100%;
        transform: rotateZ(60deg);
        animation: circular-bg 5s linear 0s infinite normal;
    }
    .circular h3{
        font-size: 48px;
    }
    .circular p{
        font-size: 50px;
        color: #eacb42;
        text-align: center;
        font-weight: bold;
    }
    .beam{
        width: 200px;
        height: 129px;
        position: absolute;
        background: url("../../assets/images/beam.png")center center no-repeat;
        background-size: 100% 100%;
        bottom: 80px;
        left: -10px;
    }
    @keyframes circular-bg {
        0% {transform: rotateZ(60deg);}
        100% {transform: rotateZ(420deg)}
    }
</style>
